import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ApplyLoadFreightMutationVariables = Types.Exact<{
  input: Types.ApplyLoadFreightInput;
}>;


export type ApplyLoadFreightMutation = { __typename?: 'Mutation', applyLoadFreight: { __typename?: 'ApplyLoadFreightPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, refusal?: { __typename?: 'LoadFreightRefusal', code: string, loadId: string, lineIds: Array<string>, message: string } | null, results: Array<{ __typename?: 'LoadFreightOrderResult', orderId: string, orderNumber: string, outcome: Types.LoadFreightOutcome, skipReason?: Types.LoadFreightSkipReason | null, warnings: Array<Types.LoadFreightWarning>, message: string, containers: number, share: number, minimum?: number | null, minimumApplied: boolean, freight: number, surcharge: number, currentFreight: number, currentSurcharge: number, unplannedContainers: number, unpricedLoadNumber?: number | null, contributions: Array<{ __typename?: 'LoadFreightContributionResult', loadId: string, loadNumber: number, carrierId: string, rateBasis: Types.CarrierRateBasis, rateAmount: number, miles?: number | null, stops: number, loadContainers: number, loadCost: number, containers: number, share: number, surchargePercent: number, portion: number, surcharge: number }> }> } };


export const ApplyLoadFreightDocument = new TypedDocumentString(`
    mutation ApplyLoadFreight($input: ApplyLoadFreightInput!) {
  applyLoadFreight(input: $input) {
    errors {
      code
      message
    }
    refusal {
      ...LoadFreightRefusalFields
    }
    results {
      ...LoadFreightOrderFields
    }
  }
}
    fragment LoadFreightRefusalFields on LoadFreightRefusal {
  code
  loadId
  lineIds
  message
}
fragment LoadFreightOrderFields on LoadFreightOrderResult {
  orderId
  orderNumber
  outcome
  skipReason
  warnings
  message
  containers
  share
  minimum
  minimumApplied
  freight
  surcharge
  currentFreight
  currentSurcharge
  unplannedContainers
  unpricedLoadNumber
  contributions {
    loadId
    loadNumber
    carrierId
    rateBasis
    rateAmount
    miles
    stops
    loadContainers
    loadCost
    containers
    share
    surchargePercent
    portion
    surcharge
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    ApplyLoadFreight: build.mutation<ApplyLoadFreightMutation, ApplyLoadFreightMutationVariables>({
      query: (variables) => ({ document: ApplyLoadFreightDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useApplyLoadFreightMutation } = injectedRtkApi;
